/**
 * @author Matěj Grabovský <matej.grabovsky@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './setup-panel-right.html';

import ClockRoot from '../clock/clock-root';

export default defineComponent({
  name: 'SetupPanelRight',
  template,
  components: { ClockRoot },
  computed: {
    networkStatus() {
      if (this.isOnline) {
        return 'setup-connectivity--online';
      }
      return 'setup-connectivity--offline';
    },
    serverStatus() {
      if (this.serverConnected) {
        return 'setup-server-connectivity--on';
      }
      return 'setup-server-connectivity--off';
    }
  },
  data() {
    return {
      delay: 1000
    };
  },
  emits: {},
  props: {
    isOnline: { type: Boolean, required: true },
    serverConnected: { type: Boolean, required: true }
  }
});
